import Gallery from "pages/Gallery";

export default function GalleryPage() {
  return <Gallery />;
}
